// @ts-ignore
import { DNA } from '@dna/core'

let x: any = DNA
// x.tokens.dimension['space'] = {}
// x.tokens.color['tone'] = {}
// x.tokens.color['brand'] = {}

export { x as DNA }
